import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { Header } from '../../../components/Header/Header'
import { StepItems } from '../../../components/StepItems/StepItems'
import { StepsActions } from '../../../components/StepsActions/StepsActions'

import { Steps, Variant } from '../../../types'
import { ContentContainer, Box } from '../../styles'

import AiWritingDesktop from '../../../assets/AI_Writing_Desktop.webm'
import AiWritingMobile from '../../../assets/AI_Writing_Mobile.webm'
import AiWritingTablet from '../../../assets/AI_Writing_Tablet.webm'

import { useGetConfig } from './useGetConfig'
import * as Styles from './styles'

type Props = {
  step: Steps
  variant: Variant
  nextStep?: Steps
  isAiResumeLoading: boolean
  setStep: (step: Steps) => void
  onFinishClick: () => void
}

export const TemplateStep = ({
  step,
  variant,
  nextStep,
  isAiResumeLoading,
  setStep,
  onFinishClick,
}: Props) => {
  const { isPhone, isTablet } = useMediaQueries()
  const { steps, header, actions } = useGetConfig(variant)

  const getSrc = () => {
    if (isPhone) return AiWritingMobile
    if (isTablet) return AiWritingTablet
    return AiWritingDesktop
  }

  const ActionsContainer = (
    <Styles.ActionsContainer data-testid="template-step-actions">
      <StepsActions
        variant={variant}
        setStep={setStep}
        onFinish={onFinishClick}
        activeStep={step}
        nextStep={nextStep}
        prevStep={Steps.WELCOME}
        backButtonText={actions.back}
        continueButtonText={actions.continue}
      />
    </Styles.ActionsContainer>
  )

  useEffect(() => {
    trackInternalEvent('leads_onboarding_2')
  }, [])

  return (
    <ContentContainer data-testid="template-step">
      <Box>
        <Styles.InfoContainer data-testid="template-step-info">
          <Header {...header} />
          <Styles.StepsContainer data-testid="template-step-items">
            <StepItems borderTop={variant === 'c'} items={steps} />
          </Styles.StepsContainer>
          {!isPhone && !isTablet && ActionsContainer}
        </Styles.InfoContainer>
      </Box>
      <Box>
        <Styles.AnimationContainer variant={variant} data-testid="template-step-animation">
          {variant === 'c' ? (
            <Styles.SliderAnimation />
          ) : isAiResumeLoading ? (
            <Styles.SliderAnimation />
          ) : (
            <Styles.Video
              src={getSrc()}
              autoPlay
              muted
              loop
              playsInline
              data-testid="template-step-video"
            />
          )}
        </Styles.AnimationContainer>
      </Box>
      {(isPhone || isTablet) && ActionsContainer}
    </ContentContainer>
  )
}
